import Icons from "@/components/Icons";

// Optimistic Google Pay button - non-clickable loading indicator
// Shows users that Google Pay is loading in that position

interface OptimisticGooglePayButtonProps {
  showUnavailableMessage?: boolean;
}

const OptimisticGooglePayButton = ({ showUnavailableMessage = false }: OptimisticGooglePayButtonProps) => {
  return (
    <div
      className="w-full h-[48px] rounded-[4px] flex items-center justify-center cursor-wait relative overflow-hidden"
      style={{
        // background: 'linear-gradient(to right, #1a1a1a, #2a2a2a)',
        background: '#36454F',
        opacity: 0.85,
        borderRadius: '6px',
      }}
    >
      {/* Shimmer effect overlay - only show when not displaying unavailable message */}
      {!showUnavailableMessage && (
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)',
            animation: 'shimmer 2s ease-in-out infinite',
            width: '200%',
          }}
        />
      )}
      
      {/* Button content */}
      <div className="flex items-center gap-1.5 relative z-10">
        {showUnavailableMessage ? (
          <>
            <span className="text-[15px] font-medium text-white" style={{ fontFamily: 'Google Sans, Roboto, Arial, sans-serif' }}>
              No
            </span>
            <div className="flex items-center justify-center align-middle mb-0.5">
              <Icons type="googleG" size={13} />
            </div>
            <span className="text-[15px] font-medium text-white" style={{ fontFamily: 'Google Sans, Roboto, Arial, sans-serif' }}>
              Pay available
            </span>
          </>
        ) : (
          <>
            <span className="text-[15px] font-medium text-white" style={{ fontFamily: 'Google Sans, Roboto, Arial, sans-serif' }}>
              Buy with
            </span>
            <div className="flex items-center justify-center align-middle mb-0.5">
              <Icons type="googleG" size={13} />
            </div>
            <span className="text-[15px] font-medium text-white" style={{ fontFamily: 'Google Sans, Roboto, Arial, sans-serif' }}>
              Pay
            </span>
          </>
        )}
      </div>
      
      {/* Add shimmer keyframes */}
      <style>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(50%);
          }
        }
      `}</style>
    </div>
  );
};

export default OptimisticGooglePayButton;
